import { render } from "./DataRole.vue?vue&type=template&id=5a26198f&scoped=true&ts=true"
import script from "./DataRole.vue?vue&type=script&lang=ts"
export * from "./DataRole.vue?vue&type=script&lang=ts"

import "./DataRole.vue?vue&type=style&index=0&id=5a26198f&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a26198f"]])

export default __exports__